import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { AccountType } from '../enum/account-type.enum';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly superAdminPages = ['0', '1', '2', '3', '4', '5', '6', '7'];

  constructor(private http: HttpClient) {}

  getAccountType():Observable<any>{
    const cached = this.getCachedAccountType();

    if (cached) {
      return of(cached);
    }

    return this.http.get(environment.Server_URL+'/get-type-user').pipe(
      map((res) => this.normalizeAccountType(res)),
      catchError(() => {
        const cached = this.getCachedAccountType();

        return cached ? of(cached) : of({ user_type: '0', access_pages: [] });
      })
    );
  }

  getUserId():Observable<any>{
    return this.http.get(environment.Server_URL+'/get-id-user');
  }
  getWarehouseType(id: number): Observable<any> {
  return this.http.get(environment.Server_URL + '/warehouse/' + id + '/type');
}

  private getCachedAccountType(): { user_type: string; access_pages: string[] } | null {
    const storedType = localStorage.getItem('user_type');

    if (!storedType) {
      return null;
    }

    return this.normalizeAccountType({
      user_type: storedType,
      access_pages: localStorage.getItem('access_pages')
    });
  }

  private normalizeAccountType(res: any): { user_type: string; access_pages: string[] } {
    const rawType =
      res?.user_type ??
      res?.type ??
      res?.user?.type ??
      localStorage.getItem('user_type');

    const userType = Number(rawType) || 0;

    return {
      user_type: String(userType),
      access_pages: this.normalizeAccessPages(
        res?.access_pages ??
        res?.accessPages ??
        res?.user?.access_pages ??
        localStorage.getItem('access_pages'),
        userType
      )
    };
  }

  private normalizeAccessPages(rawPages: any, userType: number): string[] {
    if (userType === AccountType.SuperAdmin) {
      return this.superAdminPages;
    }

    let pages = rawPages;

    if (typeof pages === 'string') {
      try {
        pages = JSON.parse(pages);
      } catch {
        pages = pages
          .split(',')
          .map((page: string) => page.trim())
          .filter(Boolean);
      }
    }

    if (!Array.isArray(pages)) {
      return [];
    }

    return pages.map((page) => String(page));
  }

}
